import { withLayout } from '../../layout';

import BusinessPage from './business.page';

export default withLayout(BusinessPage);
